import { ReactNode } from 'react';

import clsx from 'clsx';

import styles from './TableRow.module.scss';

interface TableRowProps {
  children?: ReactNode;
  className?: string;
  onClick?: () => void;
  isHoverDisabled?: boolean;
}

const TableRow = ({ children, className, onClick, isHoverDisabled = false }: TableRowProps) => {
  return (
    <div className={clsx(styles.tableRow, { [styles.disabledHover]: isHoverDisabled }, className)} onClick={onClick}>
      {children}
    </div>
  );
};

export default TableRow;
